import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "meta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createBlock(_component_entry_search, {
    "content-type": $setup.search.contentType,
    show: $props.show,
    model: $setup.search.model,
    config: $setup.search.config,
    "select-limit": $setup.search.limit,
    request: $setup.directr,
    onSelection: $setup.emitSearchResult,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false))),
    style: {"width":"320px"}
  }, {
    "search-item-content": _withCtx(({item}) => [
      _renderSlot(_ctx.$slots, "content", { item: item }, () => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(item.sku || ''), 1)
      ])
    ]),
    _: 3
  }, 8, ["content-type", "show", "model", "config", "select-limit", "request"]))
}